// extracted by mini-css-extract-plugin
module.exports = {"nave":"Paginacion_nave__1hc9Z"};